export default class InputPlace
{
  constructor(id, place, image) 
  {
    
    this.id = id;
    this.place = place;
    this.image = image;
  }    
}